import { useEffect, useRef } from 'react';
import { reconcileTrialCardCapture } from '@extension/wa-communication-layer/api/api-calls';
import { isTrialCardReturn, withoutTrialCardReturn } from './trial-card-return-logic';

/**
 * #1229: on return from the Chargebee hosted page, ask the server to reconcile the pending consent
 * (the payment_source_added webhook may not have arrived). Renders nothing. The server applies the
 * same flag, allowlist and guards as the webhook and answers `disabled` while the feature is off,
 * so this is inert by default. A failure never blocks the app. The marker is removed from the URL first.
 */
export const TrialCardReturn: React.FC = () => {
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current) return;
    const { search, pathname, hash } = window.location;
    if (!isTrialCardReturn(search)) return;
    firedRef.current = true;
    window.history.replaceState(window.history.state, '', withoutTrialCardReturn(search, pathname, hash));
    reconcileTrialCardCapture().catch(() => { /* the sweep covers a failed return call */ });
  }, []);

  return null;
};
